import { AgmInfoWindow } from "@agm/core";
import { Injectable } from "@angular/core";
import { makeStateKey, TransferState } from "@angular/platform-browser";

import { Pitch } from "../shared/model/pitch";
import { Venue } from "../shared/model/venue";
import { MlpHelper } from "../shared/mlpHelper";
import { DateService } from "../shared/date.service";
import { ICreateDates } from "./search.service.interface";
import { PitchCollection } from "../shared/model/pitchCollection";

const SEARCHDATA = makeStateKey("searchData");

@Injectable({
    providedIn: "root",
})
export class SearchService {
    initSearchResultsPage = true;
    initialLoading = true;
    public lat: number;
    public lng: number;
    public loading: boolean = true;
    public searchTerm: string;
    public radius = "";
    public page: number = 1;
    public perPage: number = 10;
    public searchResults: PitchCollection;
    public searchResultsOnlineOnly: number = 0;
    public councilInfo: string;
    public showMap: boolean = false;
    public allowSearchAndMove: boolean = false;
    venuesOnMap: Array<Venue> = [];
    starts: string;
    ends: string;
    startDate: Date;
    timeSearchSports = ["football", "badminton", "tennis", "squash"];
    autoCompleteSearchNoResults = false;
    allowMapIdle = true;
    lastMapMarkerPopup: AgmInfoWindow;
    filters = {
        online_booking: false,
        is_partner: false,
    };

    constructor(
        private transferState: TransferState,
        private dateService: DateService
    ) {
        const searchData = this.transferState.get(
            SEARCHDATA,
            undefined as PitchCollection
        );

        if (searchData) this.searchResults = searchData;
    }

    isApprovedSport(sport: string): boolean {
        return !!this.timeSearchSports.filter((item) => item === sport)[0];
    }

    createInitialDates(
        year: number,
        month: number,
        day: number,
        hour: number,
        minute: number
    ): ICreateDates {
        const time = this.dateService.createFilterTime(hour, minute);
        const date = this.dateService.createFilterDate(year, month, day);

        let incrementHours = 3;

        switch (hour) {
            case 21:
                incrementHours = 2;
                break;
            case 22:
                incrementHours = 1;
                break;
            case 23:
                incrementHours = 0;
                break;
            default:
                incrementHours = 3;
        }

        const endTime = this.dateService.createFilterTime(
            hour + incrementHours,
            0
        );
        const endDate = this.dateService.createFilterDate(year, month, day);

        return { time, date, endTime, endDate };
    }

    getVenuesWithRelationshipToResults(
        pitchCollection: PitchCollection
    ): Array<Venue> {
        const venues = [];

        if (pitchCollection.data.length > 0) {
            pitchCollection.included.forEach((venue: Venue) => {
                const newVenue = venue;
                newVenue.relationships.pitches.data = [];

                pitchCollection.data.forEach((pitch: Pitch) => {
                    const venueId = pitch.relationships.venues.data.id;
                    if (venueId == venue.id) {
                        newVenue.relationships.pitches.data.push(pitch);
                    }
                });

                venues.push(newVenue);
            });
        }

        return venues;
    }

    sortAgg(items: Array<any>): Array<any> {
        return items.sort((one, two) =>
            MlpHelper.sortAlphaNum(one.key, two.key)
        );
    }

    reset(): void {
        this.searchResults = undefined;
        this.initialLoading = false;
        this.loading = false;
    }

    closeLastMapMarkerPopup(): void {
        if (
            this.lastMapMarkerPopup !== null &&
            this.lastMapMarkerPopup !== undefined
        ) {
            if (this.lastMapMarkerPopup) this.lastMapMarkerPopup.close();
            this.lastMapMarkerPopup = undefined;
        }
    }
}
